<template>
  <div class="WhereLibUsedComponent DataTables">
    <p>{{lang.infotext_1}}:</p>

    <div v-show="isData" :id="id"></div>

    <LoaderComponent  v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from '@/Tools/Tools'
import LibraryTypes from '@/constants/LibraryTypes'

export default {
  name: 'WhereLibUsedComponent',
  props:{
    lang: Object,
    parent: String
    
  },
  components: {
    LoaderComponent

  },
  data () {
      return {
        name: 'WhereLibUsedComponent',
        mainTable: "",
        id: "WhereLibUsedComponent" + this._uid,
        columns: [],
        colsAssign: [],
        elements: [],
        isData: false,
        
      }
  },
  computed: {
    ...mapGetters([
      'selectedRevisionRow',

    ]),
    revisionId(){

      if (this.parent == "bom"){
        return this.$store.getters.selectedPartBomRow.revisionId;
      }
      
      if (this.$route.path == "/LibraryManager/LibraryTable") {
        if (this.$store.getters.selectedRows[0] != undefined) {
          
          return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
        }
      }
      if (this.$route.path == "/LibraryManager/LibraryDetails") {
        
        if (this.$store.getters.selectedRevisionRow.length == 0) {
            return null;
        }
        if (this.$store.getters.selectedRevisionRow[0] == undefined) {

            return this.$store.getters.selectedRevisionRow[0].revisionId;
        }
        return this.$store.getters.selectedRevisionRow[0].revisionId;
      }
      return ""
      
      


    },
    elementId(){
      
            
      if (this.$store.getters.selectedRows[0] != undefined) {
        if (this.$route.path == "/LibraryManager/LibraryTable") {
          
          return this.$store.getters.selectedRows[0].col___revisionId.libraryId;
        
        }
        if (this.$route.path == "/PartManager/PartTable") {
          
          return this.$store.getters.selectedRows[0].col___revisionId.partId;
        
        }
      }
      if (this.$route.path == "/LibraryManager/LibraryDetails") {
        
        return this.$route.query.id;
      
      }
      if (this.$route.path == "/PartManager/PartDetails") {
       
        return this.$route.query.id;

      }
      if (this.$route.path == "/ProjectManager/ProjectBom") {
       
        return this.$route.query.id;

      }


     
      return "";
    },
    
    reloadedAfterActionComplex(){
        return this.$store.getters.reloadedAfterActionComplex;
    }

  },
  created () {

    this.createTable();


  },
  watch: {
    revisionId: {
      handler: function(newVal, oldVal){
        console.log(newVal)
        this.createTable();
      },
      deep: true
    
      
    },
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.createTable();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    
  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    createTable() {
      this.isData = false;
      let vue = this;

      let prefix = this.$store.getters.sectionPrefix;
      if (this.parent == "bom") {
        prefix = "lm";
      }

      let obj = {
      
          libraryRevisionId: this.revisionId
      
        
      }
     
      
      this.$store.dispatch(prefix + "_whereLibUsed", obj)
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){

          this.elements = result.data;
          vue.isData = true;  
          


          vue.buildColumns();


        }else{
            vue.isData = false;  
        }


      })
    },
    buildColumns(){

      this.columns = [
        {
          name: "Id",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Name,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Revision,
          alignInColumn: "left",
          type: "taxt"
        },
        {
          name: this.lang.table_header_Type,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Status,
          alignInColumn: "left",
          type: "text"
        },
        
      ]

      this.colsAssign =  [
        { "data": "revisionId" },
        { "data": "name" },
        { "data": "revision" },
        { "data": "type"},
        { "data": "status"},
               
      ]

      this.buildTable();
    },
    buildTable(){
          
      var tableplace = document.getElementById(this.id);
      if (tableplace == null){
        return;
      }

      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var table = document.createElement("table");
      table.setAttribute("id", "t_" + this.id);
      table.setAttribute("style", "width:100%");
      table.setAttribute("class", "table table-striped table-bordered");
      tableplace.appendChild(table)

      var tr = document.createElement("tr");
      tr.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr);
      table.appendChild(thead);

      var _vue = this;


      let columnDefs = [];
      var len = this.columns.length;
      for (var i = 0; i < len; i++){

        var el = {};

        var classname = '_dt-body-'+ this.columns[i].alignInColumn;

        el = {
          targets: i,
          className: classname,

          render: function ( data, type, row, meta ) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

            if (meta.col == 4){
              if (data == null){
                return "";
              }
              let variant = Tools.getStatusColor(data);
              return "<b-badge class='badge badge-"+variant+" '>"+data+"</b-badge>";
            }
            

            return data;
          }


        }

        columnDefs.push(el);


        var th = document.createElement("th");
        tr.appendChild(th);
        //var p = document.createElement("p");
        //th.appendChild(p);
        var br = document.createElement("br");
        th.appendChild(br);
        var tx = document.createTextNode(this.columns[i].name)
        th.appendChild(tx);

      }


      var option = {};
      option.paging = true;
      option.info = true;
      option.dom = '<fr<t>ip>';
      option.data= this.elements;
      option.myColumnFormats = this.columns;
      option.select = true;
      option.order = [[3, "asc"]];
      option.lengthMenu = [[20]];
      option.columns = this.colsAssign;

      option.columnDefs = columnDefs;
      option.initComplete = function () {


        

      }




      if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
          this.mainTable.destroy();
          
      }

      var _vue = this;

      this.mainTable = $('#t_'+this.id).DataTable(option);

      this.mainTable.columns.adjust().draw();

      //hide first column in table
      this.mainTable.column( 0 ).visible( false );

      let _mainTable = this.mainTable;

      // this.mainTable
      //   .on( 'select', function ( e, dt, type, indexes ) {

      //     var rowData = _mainTable.rows( indexes ).data();





      //   })
      //   .on( 'deselect', function ( e, dt, type, indexes ) {


      //   })
      this.mainTable
        .on('dblclick', 'tr', function () {
          

          let rowData = _mainTable.rows(this._DT_RowIndex).data();
          
          _vue.goTo(rowData[0]);

          

        });

      

      //search input change view
      var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }
      searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm")


    },
    
    goTo(goalObj) {
      

      let to = "/ProjectManager/ProjectDetails";
      let id = "";
      
      let obj = {};
      if (goalObj.type == "part") {
        to = "/PartManager/PartDetails";
        id = goalObj.partId;
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            partId: id,
            userId: goalObj.userId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            partId: id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            partId: id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            partId: id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            partId: id,
            value: {
              display: ""
            }
          },
          
        }
      }
      
      if (goalObj.type == LibraryTypes.PADSTACK || goalObj.type == LibraryTypes.FOOTPRINT) {
        
        to = "/LibraryManager/LibraryDetails";
        id = goalObj.libraryId;
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            userId: goalObj.userId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }
          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            libraryType: goalObj.type,
            value: {
              display: goalObj.type
            }
          },
          
        }
      }

       

      

      //this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setOneSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      let sourceType = "main";
      if (this.$route.path == "/LibraryManager/LibraryDetails"){
        sourceType = "details";
      }
      if (this.$route.path == "/PartManager/PartDetails"){
        sourceType = "details";
      }
      if (this.$route.path == "/ProjectManager/ProjectBom"){
        sourceType = "details";
      }

      
      let routingObject = {
        from: this.$route.path,
        to: to,
        revisionId: goalObj.revisionId,
        id: id,
        sourceType: sourceType, //"details"
        sourceId: this.elementId,
        sourceRevisionId: this.revisionId,
        end: false
        
      }
      
      this.$store.commit("FORWARDROUTINGDATA", routingObject)

      // const query = {
      //   from: this.$route.path,
      //   to: to,
      //   revisionId: goalObj.revisionId,
      //   id: id,
      //   sourceId: this.elementId,
      //   sourceRevisionId: this.revisionId,
      //   end: false
      // }
      if (this.$route.path == to) {
        
        to = "/LibraryManager/LibraryRouting";
      }

      this.$router.push({ path: to, query: routingObject });
    },

  }
}
</script>


<style lang="scss">
  .WhereLibUsedComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/WhereLibUsedComponent.vue